import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles'
import { InputBase } from '@material-ui/core'
import { Autocomplete } from '@react-google-maps/api'

const useStyles = makeStyles((theme) => ({
    input: {
        width: '100%',
        fontSize: '1.2rem',
        padding: '0.5em 0.75em',
        height: '2.5em',
        maxWidth: '100%',
        border: '1px solid #dbdbdb',
        borderRadius: '4px',
        backgroundColor: '#fff',
        color: '#363636',
        boxShadow: 'inset 0 1px 2px rgba(10,10,10,.1)',
        '&::placeholder': {
            color: '#7a7a7a',
            opacity: 1,
        },
        '&:focus': {
            borderColor: '#3273dc',
            boxShadow: '0 0 0 0.125em rgba(50,115,220,.25)',
            outline: 'none',
        },
        '&:hover': {
            borderColor: '#b5b5b5',
        },
    },
}))

var autocomplete;

const PlaceSearchBox = props => {
    const classes = useStyles();

    useEffect(() => {
        var input = document.getElementById('placesearch');
        input.value = props.value ? props.value : '';
    }, [props.value])

    const onLoad = (instance) => {
        autocomplete = instance
    }

    const onPlaceChanged = () => {
        if (autocomplete) {
            props.onPlaceChanged(autocomplete.getPlace())
        } else {
            console.log('Autocomplete is not loaded yet!')
        }
    }

    return (
        <Autocomplete
            onLoad={onLoad}
            onPlaceChanged={onPlaceChanged}
            restrictions={{ 'country': ['nz', 'jp'] }}
        >
            <InputBase
                id="placesearch"
                className={classes.input}
                inputProps={{
                    onBlur: props.onBlur,
                    onChange: props.onChange,
                    onKeyPress: (e) => { e.key === 'Enter' && e.preventDefault(); },
                    placeholder: props.placeholder,
                }}
            />
        </Autocomplete>
    )
}

PlaceSearchBox.propTypes = {
    placeholder: PropTypes.string,
    value: PropTypes.string,
    onPlaceChanged: PropTypes.func,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
}

export default PlaceSearchBox
